import { Stat } from "../../components/Stat";
import { useConfig } from "../../hooks/useConfig";
import { formatCad } from "./Ledger";
import { useStats } from "../../hooks/useStats";
import { formatCount } from "../../lib/format";

/** Counters served by GET /api/stats. Nothing here is hardcoded. */
export function LiveStats() {
  const { config } = useConfig();
  const donated = config?.donations?.totalCad ?? 0;
  const { stats, loading } = useStats();
  const dash = loading ? "..." : "n/a";

  return (
    <section className="shell section section--tight" aria-label="Airdrop numbers">
      <div className="grid-3">
        <Stat value={formatCad(donated)} label="Donated to the charity so far" />
        <Stat value={stats ? formatCount(stats.eligible) : dash} label="Wallets eligible for the airdrop" />
        <Stat
          value={stats ? formatCount(stats.registered) : dash}
          label="Eligible wallets registered so far"
        />
        <Stat
          value={stats && stats.claimed !== null ? formatCount(stats.claimed) : "Not open"}
          label="Claims made"
        />
      </div>
      {config?.snapshot.takenAt ? (
        <p className="tiny" style={{ marginTop: "var(--gap-5)" }}>
          Snapshot taken {config.snapshot.takenAt}.
        </p>
      ) : null}
    </section>
  );
}
